import type { SendCapabilityReport, SendRuleOutcome } from '@/model/Agent.model';

type SendRuleTier = SendRuleOutcome['tier'];
type SendDefinitionSource = keyof SendCapabilityReport['register']['by_definition_source'];
type SendRoute = keyof SendCapabilityReport['register']['by_route'];

/** Each validation tier, by what its rules examine. Tier 8 is ours alone and never counted against a published total. */
export const TIER_TEXT: Record<SendRuleTier, string> = {
  tier_0: 'Tier 0 · Package structure',
  tier_1: 'Tier 1 · File format',
  tier_2: 'Tier 2 · Structure',
  tier_3: 'Tier 3 · Controlled terminology',
  tier_4: 'Tier 4 · Value-level coherence',
  tier_5: 'Tier 5 · Cross-domain integrity',
  tier_6: 'Tier 6 · define.xml',
  tier_7: 'Tier 7 · Regulatory submission requirements',
  tier_8: 'Tier 8 · Data quality',
  unclassified: 'Unclassified',
};

/** Where a published rule's check comes from, as the capability audit found it. */
export const DEFINITION_SOURCE_TEXT: Record<SendDefinitionSource, string> = {
  published_encoding: "CDISC's published encoding",
  derived_from_spec: "Our check, derived from CDISC's prose",
  no_check: 'No possible check',
};

/** The route planned for a published rule: a work assignment, not where its check comes from. */
export const ROUTE_TEXT: Record<SendRoute, string> = {
  published_encoding: "ported from CDISC's encoding",
  derive_in_m1: 'routed for a check we derive',
  deferred_to_m2: 'waiting on the transport file or define.xml',
  undeterminable: "that no submission's data can decide",
};

/** The text a tier key reads as; a key this build doesn't know reads as itself. */
export const tierText = (key: string): string => (key in TIER_TEXT ? TIER_TEXT[key as SendRuleTier] : key);

/** The text a definition-source key reads as. */
export const definitionSourceText = (key: string): string =>
  key in DEFINITION_SOURCE_TEXT ? DEFINITION_SOURCE_TEXT[key as SendDefinitionSource] : key;
